import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HTTP_PREVENT_DEFAULT_ON_ERROR_TOKEN } from '@core/http-legacy';
import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

@Injectable({ providedIn: 'root' })
export class IntelligenceAnalyticsHttpClient {
  private readonly http = injectTellentIntelligenceHttp();

  public track(event: string, data: object) {
    const httpContext = new HttpContext().set(HTTP_PREVENT_DEFAULT_ON_ERROR_TOKEN, true);
    return this.http.post(`/analytics/track`, null, { event, data }, { httpContext });
  }
}
